module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av146-2002815166d4aa1ffce82e80ab1d8b7d.jpg";